export const regularExpressions = {
  letters: /^[a-zA-Z]*$/gm,
  lettersAndWhiteSpaces: /^[a-zA-Z ]*$/gm,
  digits: /^[0-9]*$/gm,
  betweenZeroAndHundred: /^(100|[1-9]?[0-9])$/gm,
  betweenOneAndHundred: /^(?:100?|(^[1-9])?([0-9])(?:\.\d?)?)$/gm,
}
